module.exports = __webpack_public_path__ + "omlazeni-pleti_1_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/laserova-estetika/omlazeni-pleti_1_after_tn.jpg
// module id = 1481
// module chunks = 0